export function shouldRedirectToNewMentor(requestedTenant) {
  const tenantsThatDontNeedRedirect =
    process.env.REACT_APP_IBL_TENANTS_THAT_DONT_REDIRECT_TO_NEW_MENTOR?.split(
      ','
    );
  const foundTenant = tenantsThatDontNeedRedirect.find((tenant) =>
    requestedTenant.includes(tenant)
  );
  return foundTenant === undefined;
}
